<template>
<fragment>
    <tr v-if="!loading && line">
        <td>
            {{ line.lot.number }} - {{ line.lot.name }}
            <span class="d-block">{{ line.designation }}</span>
            <span class="d-block ix-text-small ix-text-secondary">{{ line.lot.deal.number }} - {{ line.lot.deal.name }}</span>
        </td>
        <td>
            <input type="time" class="form-control" :name="'lines[' +  line.id + '][duration]'" v-model="line.duration" required :class="{'checking-duration-warning': isLongDuration()}">
            <small v-if="isLongDuration()" class="text-warning d-block mt-1">
                Pointage anormalement long (&gt; {{ maxHoursPerDay || 12 }}h)
            </small>
        </td>
         <td class="text-right">
            <div class="custom-control custom-switch custom-switch-md">
                <input type="checkbox" class="custom-control-input" :id="'customSwitch' + line.id + ''" :name="'lines['+ line.id + '][end]'" value="0" v-model="line.operation_done">
                <label class="custom-control-label" :for="'customSwitch' +  line.id + ''"></label>
            </div>
        </td>
        <td class="text-right">
            <button type="button" class="ix-btn transparent" @click="openMovementCheckingModal">Sorties de stocks</button>
        </td>
    </tr>
    <tr v-if="line.movements && line.movements.designation != null" style="background: #0366D6">
        <td colspan="4" class="text-center">
            <span class="d-block text-white"><b>Sorties de stocks</b></span>
        </td>
    </tr>
    <tr v-if="line.movements && line.movements.designation != null">
        <td colspan="3">
            <span class="d-block ix-text-small ix-text-secondary" v-if="line.movements">Motif :
                 <span v-if="line.movements.designation"><b>{{ line.movements.designation }}</b></span>
                 <span v-if="!line.movements.designation"><b>Non renseigné</b></span>
                 <input type="hidden" class="form-control" :name="'lines[' + line.id +'][movements][designation]'" v-model="line.movements.designation" />
            </span>
        </td>
        <td class="text-right">
            <span class="d-block ix-text-small ix-text-secondary" v-if="line.movements">Le : <b>{{ line.movements.date_at }}</b></span>
            <input type="hidden" class="form-control" :name="'lines[' + line.id +'][movements][date_at]'" v-model="line.movements.date_at" />
        </td>
    </tr>
    <fragment v-if="line.movements">
        <tr v-for="(article, index) in line.movements.articles" :key="index">
            <td colspan="3">
                <span class="d-block">
                    {{ article.name }}
                </span>
                 <span class="d-block ix-text-small ix-text-secondary">
                     Quantité : <b>{{ article.quantity }}</b>
                 </span>
                <input type="hidden" class="form-control" :name="'lines[' + line.id +'][movements][articles][' + article.id + '][id]'" v-model="line.movements.articles[index].id" />
                <input type="hidden" class="form-control" :name="'lines[' + line.id +'][movements][articles][' + article.id + '][designation]'" v-model="line.movements.articles[index].name" />
                <input type="hidden" class="form-control" :name="'lines[' + line.id +'][movements][articles][' + article.id + '][quantity]'" v-model="line.movements.articles[index].quantity" />
            </td>
            <td class="text-right">
                  <span class="btn btn-sm transparent" @click="deleteMovement(index)">
                    <i class="far fa-trash"></i>
                </span>
            </td>
        </tr>
    </fragment>
</fragment>
</template>

<script>
import $ from 'jquery' ;

export default {
    name: 'precheckings-form',
    props: ['line' , 'index' , 'articleUrl', 'duration', 'maxHoursPerDay'],
    data() {
        return {
            loading: true,
            movements : {
                designation : null,
                date_at : null,
                articles : [],
            }
        }
    },
    methods : {
        compute: function(){
            this.line.duration = this.line.duration ? this.line.duration : this.duration;
            this.line.operation_done = this.line.operation_done ? this.line.operation_done : 0
            this.line.movements = this.line.movements ? this.line.movements : this.movements;
        },
        openMovementCheckingModal(){
            this.$emit('open-movement-checking-modal', {line : this.line , index : this.index, movements : this.line.movements});
        },
        deleteMovement(index){
            this.line.movements.articles.splice(index , 1);
            if(this.line.movements.articles.length == 0){
                this.line.movements.designation = null;
                this.line.movements.date_at = null;
                this.line.movements.articles = [];
            }
        },
        isLongDuration: function() {
            if (!this.line || !this.line.duration) {
                return false;
            }
            const parts = this.line.duration.split(':');
            if (parts.length !== 2) {
                return false;
            }
            const h = parseInt(parts[0], 10);
            const m = parseInt(parts[1], 10);
            if (isNaN(h) || isNaN(m)) {
                return false;
            }
            const totalMinutes = h * 60 + m;
            const maxMinutes = (this.maxHoursPerDay || 12) * 60;
            return totalMinutes > maxMinutes;
        }
    },
    mounted(){
        this.compute();
        this.loading = false;
    }
}
</script>